/**
 * CR3 — Suggested action catalog (workspace capability hints)
 *
 * Consumers: Capability Resolver track (CR1+) — action chips / empty-state CTAs.
 */

export interface SuggestedActionEntry {
  key: string;
  label: string;
  flowTemplateId?: string;
  requiredCapability?: string;
}

export const SUGGESTED_ACTION_REGISTRY: readonly SuggestedActionEntry[] = [
  {
    key: 'start_price_change_flow',
    label: '가격 변경 Flow 시작',
    flowTemplateId: 'v2.field_value_change',
    requiredCapability: 'flow:execute',
  },
  {
    key: 'request_approval',
    label: '승인 요청',
    requiredCapability: 'flow:approve',
  },
  {
    key: 'start_flow',
    label: 'Flow 시작',
    requiredCapability: 'flow:execute',
  },
] as const;

const SUGGESTED_ACTION_BY_KEY = new Map(
  SUGGESTED_ACTION_REGISTRY.map((entry) => [entry.key, entry] as const)
);

export function getSuggestedAction(key: string): SuggestedActionEntry | undefined {
  return SUGGESTED_ACTION_BY_KEY.get(key);
}
